import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import Main from "./Main";
import Footer from "./Footer";
import FooterMin from "./FooterMin";
import CookieConsent from "react-cookie-consent";

// First Component loaded - 'Homepage'
class App extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { location, history } = this.props;
        if (location.pathname.includes("community2")) {
            return (
                <div>
                    <Main />
                </div>
            );
        } else {
            return (
                <div>
                    <Main />
                    <Footer />
                    <CookieConsent buttonText="I accept" expires={150}>
                        We use cookies to ensure that we give you the best
                        experience on our website.{" "}
                        <Link to="cookie-policy/">» Read More</Link>
                    </CookieConsent>
                </div>
            );
        }
    }
}

export default withRouter(App);
